<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="省区">
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="城市">
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="区县">
                    <el-input
                      v-model="dialogAddEditViewForm.countyName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="零售户">
                    <el-input
                      v-model="dialogAddEditViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="档位">
                    <el-input
                      v-model="dialogAddEditViewForm.levelName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="到货周期">
                    <el-input
                      v-model="dialogAddEditViewForm.receiptDayStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="采集人">
                    <el-input
                      v-model="dialogAddEditViewForm.collectionUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本周期到货日期"
                    prop="periodReceiptDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.periodReceiptDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择到货日期"
                      :clearable="false"
                      :editable="false"
                      :disabled="eventType === 'view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="采集日期"
                    prop="collectionDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.collectionDate"
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择采集日期"
                      :clearable="false"
                      :editable="false"
                      :disabled="eventType === 'view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="采集方式">
                    <el-input
                      v-model="dialogAddEditViewForm.collectionTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="本周总销售(条)"
                    prop="weekSalesAmount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.weekSalesAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'weekSalesAmount')}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="当前总库存(条)"
                    prop="inventoryAmount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.inventoryAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'inventoryAmount')}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="云产烟总销售(条)"
                    prop="yunWeekSalesAmount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.yunWeekSalesAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'yunWeekSalesAmount')}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="云产烟总库存(条)"
                    prop="yunInventoryAmount"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.yunInventoryAmount"
                      :disabled="eventType === 'view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'yunInventoryAmount')}"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              采集信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-table
                    :data="itemListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                    :show-summary="eventType === 'view'"
                    :summary-method="getSummaries"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="productName"
                      label="品规"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.productName }}
                      </template>
                    </el-table-column>
                    <el-table-column label="上周期库存(条)">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.lastInventoryAmount"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'lastInventoryAmount')}"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="本周期到货(条)">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.orderAmount"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'orderAmount')}"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="当前库存(条)">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.inventoryAmount"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'inventoryAmount')}"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="本周期销售(条)">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.salesAmount"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'salesAmount')}"
                        />
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label="包零售价">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.packagePrice"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'packagePrice')}"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="条零售价">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.orderPrice"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'orderPrice')}"
                        />
                      </template>
                    </el-table-column> -->
                    <el-table-column label="本码出货价">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.codeSalesPrice"
                          :disabled="eventType === 'view'"
                          @input="(val)=>{limitPositiveNumber(val, scope.row, 'codeSalesPrice')}"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
import { initStoreApi } from '@/api/store'
import { initRetailSurveyInfoApi, saveOrUpdateRetailSurveyInfoApi } from '@/api/retailSurveyInfo'
export default {
  components: {},
  mixins: [dialogDragMixin, setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        periodReceiptDate: [{ required: true, message: '请选择到货日期', trigger: 'change' }],
        collectionDate: [{ required: true, message: '请选择采集日期', trigger: 'change' }],
        weekSalesAmount: [{ required: true, message: '请输入本周总销售', trigger: 'blur' }],
        inventoryAmount: [{ required: true, message: '请输入当前总库存', trigger: 'blur' }],
        yunWeekSalesAmount: [{ required: true, message: '请输入云产烟总销售', trigger: 'blur' }],
        yunInventoryAmount: [{ required: true, message: '请输入云产烟总库存', trigger: 'blur' }]
      },
      itemListData: []
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.itemListData = []
        this.dialogAddEditViewForm = {
          id: '',
          provinceName: '',
          cityName: '',
          countyName: '',
          storeName: '',
          receiptDayStr: '',
          collectionUserName: '',
          levelName: '',
          periodReceiptDate: '',
          collectionDate: '',
          collectionTypeStr: '',
          weekSalesAmount: null,
          inventoryAmount: null,
          yunWeekSalesAmount: null,
          yunInventoryAmount: null
        }
        if (this.eventType !== 'add') {
          this.initPageData()
        } else {
          this.loading = false
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData() {
      initRetailSurveyInfoApi({ id: this.dataId }).then(res => {
        const { bill, itemList } = res.data
        for (let key in this.dialogAddEditViewForm) {
          if (key !== 'collectionDate' && key !== 'periodReceiptDate')
            this.dialogAddEditViewForm[key] = bill[key]
        }
        initStoreApi({ id: bill.storeId }).then(res1 => {
          this.dialogAddEditViewForm.provinceName = res1.data.provinceName
          this.dialogAddEditViewForm.cityName = res1.data.cityName
          this.dialogAddEditViewForm.countyName = res1.data.countyName
          this.dialogAddEditViewForm.storeName = res1.data.storeName
        })
        this.dialogAddEditViewForm.collectionDate = bill.collectionDateStr
        this.dialogAddEditViewForm.periodReceiptDate = bill.periodReceiptDateStr
        this.dialogAddEditViewForm.id = bill.id
        this.itemListData = itemList
        this.loading = false
      })
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (index === 1 || index === 6) {
          sums[index] = '';
          return;
        }
        let values = 0
        if (index === 2) {
          values = data.map(item => Number(item.lastInventoryAmount));
        } else if (index === 3) {
          values = data.map(item => Number(item.orderAmount));
        } else if (index === 4) {
          values = data.map(item => Number(item.inventoryAmount));
        } else if (index === 5) {
          values = data.map(item => Number(item.salesAmount));
        }
        if (!values.every(value => isNaN(value))) {
          let total = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return (prev + curr);
            } else {
              return prev;
            }
          }, 0);
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    // 加载数据
    reloadData() {
      this.$emit('reloadData')
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave() {
      // let orderEmpty = false
      // let inventoryEmpty = false
      // let packagePriceEmpty = false
      // let orderPriceEmpty = false
      this.itemListData.forEach(item => {
        item.isComplete = 1
        if (item.orderAmount === null || item.orderAmount === '' || item.orderAmount === undefined) {
          // orderEmpty = true
          item.isComplete = 0
        }
        if (item.inventoryAmount === null || item.inventoryAmount === '' || item.inventoryAmount === undefined) {
          // inventoryEmpty = true
          item.isComplete = 0
        }
        // if(item.packagePrice === null || item.packagePrice === '' || item.packagePrice === undefined){
        //   // packagePriceEmpty = true
        //   item.isComplete = 0
        // }
        // if(item.orderPrice === null || item.orderPrice === '' || item.orderPrice === undefined){
        //   // orderPriceEmpty = true
        //   item.isComplete = 0
        // }
      })
      // if(orderEmpty){
      //   this.$message({
      //     message: '本周期到货条数不能为空',
      //     type: 'warning'
      //   })
      //   return false
      // }
      // if(inventoryEmpty){
      //   this.$message({
      //     message: '当前库存不能为空',
      //     type: 'warning'
      //   })
      //   return false
      // }
      // if(packagePriceEmpty){
      //   this.$message({
      //     message: '包零售价不能为空',
      //     type: 'warning'
      //   })
      //   return false
      // }
      // if(orderPriceEmpty){
      //   this.$message({
      //     message: '条零售价不能为空',
      //     type: 'warning'
      //   })
      //   return false
      // }
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '零售监测信息', '系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              let itemData = []
              this.itemListData.forEach(item => {
                itemData.push({
                  productId: item.productId,
                  orderAmount: item.orderAmount,
                  inventoryAmount: item.inventoryAmount,
                  lastInventoryAmount: item.lastInventoryAmount,
                  salesAmount: item.salesAmount,
                  packagePrice: item.packagePrice,
                  orderPrice: item.orderPrice,
                  codeSalesPrice: item.codeSalesPrice,
                  isComplete: item.isComplete
                })
              })
              this.dialogAddEditViewForm.itemData = JSON.stringify(itemData)
              this.dialogAddEditViewForm.isWebEdit = '1'
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存新增
    saveOrUpdate() {
      saveOrUpdateRetailSurveyInfoApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
</style>
